import { BlacklistToken, GenerateNewTokens } from 'app/redux/actions/auth';
import instance from 'app/redux/instance';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import store from 'store/index';

export const generateNewAccessToken = async dispatch => {
  const refreshToken = Cookies.get('refreshToken');

  if (!refreshToken) throw new Error('No refresh token found');

  const newTokens = await dispatch(GenerateNewTokens(refreshToken));

  const newAccessToken = newTokens.access;
  const newRefreshToken = newTokens.refresh;

  const { exp: newAccessTokenExp } = jwtDecode(newAccessToken);
  const { exp: newRefreshTokenExp } = jwtDecode(newRefreshToken);

  // Set tokens in cookies
  Cookies.set('accessToken', newAccessToken, {
    expires: new Date(newAccessTokenExp * 1000),
  });
  Cookies.set('refreshToken', newRefreshToken, {
    expires: new Date(newRefreshTokenExp * 1000),
  });

  // Set new token in axios headers
  instance.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;

  return newAccessToken;
};

export const deleteAllCookies = () => {
  const allCookies = Cookies.get(); // Get all cookies

  for (const cookie in allCookies) {
    // Delete each cookie
    Cookies.remove(cookie);
  }
};

export const performLogout = async onFinish => {
  const refreshToken = Cookies.get('refreshToken');

  try {
    if (refreshToken) await store.dispatch(BlacklistToken(refreshToken));
  } catch (error) {
    console.warn('Failed to blacklist token, continuing logout.');
  }

  deleteAllCookies();

  localStorage.clear();

  delete instance.defaults.headers.common.Authorization;

  if (typeof onFinish === 'function') onFinish();
};
